import type { Product } from '../../../data/product';
import { hasPricingData, isActiveProduct } from '../../../data/product';
import type { Vendor, VendorIntegration } from '../../../data/vendor';
import type { ProductOrderItem } from './data/product-order-item';

/**
 * The projection order-editor tables hand `remapColumn`: their rows are
 * ProductOrderItems, and every Product column reads the product off one.
 * Named because the annotation is what lets `remapColumn` infer the row type —
 * the array literals it is called in carry no contextual type.
 */
export const toProduct = (orderItem: ProductOrderItem): Product => orderItem.product;

export function matchesSize(product: Product, sizes: string[]) {
  if (sizes.length === 0) {
    return true;
  }

  return sizes.includes(product.size);
}

/**
 * Buyup membership test. With `includeInactive=false` (default), inactive
 * products are filtered out — set it to true when the caller renders its
 * own dim/badge treatment for inactive rows.
 */
export function matchesIsBuyup(product: Product, isBuyup: boolean, includeInactive = false) {
  if (!isBuyup) {
    return true;
  }

  if (!includeInactive && !isActiveProduct(product)) {
    return false;
  }

  return hasPricingData(product);
}

export function vendorHasVolumePricing(vendor: Vendor, integrations: VendorIntegration[]): boolean {
  if (!vendor.normalized_name) {
    return false;
  }

  const integ = integrations.find((i) => i.normalized_name === vendor.normalized_name);

  return integ?.pricing?.has_volume_pricing === true;
}
